var map = {
	"./east/frame_000.png": 5719,
	"./east/frame_001.png": 2702,
	"./east/frame_002.png": 4501,
	"./east/frame_003.png": 5084,
	"./north-east/frame_000.png": 9541,
	"./north-east/frame_001.png": 7916,
	"./north-east/frame_002.png": 8599,
	"./north-east/frame_003.png": 2814,
	"./north-west/frame_000.png": 5683,
	"./north-west/frame_001.png": 1578,
	"./north-west/frame_002.png": 2689,
	"./north-west/frame_003.png": 8824,
	"./north/frame_000.png": 7285,
	"./north/frame_001.png": 1372,
	"./north/frame_002.png": 4023,
	"./north/frame_003.png": 1534,
	"./south-east/frame_000.png": 6163,
	"./south-east/frame_001.png": 8586,
	"./south-east/frame_002.png": 8753,
	"./south-east/frame_003.png": 888,
	"./south-west/frame_000.png": 8965,
	"./south-west/frame_001.png": 6700,
	"./south-west/frame_002.png": 5703,
	"./south-west/frame_003.png": 3214,
	"./south/frame_000.png": 51,
	"./south/frame_001.png": 8138,
	"./south/frame_002.png": 9217,
	"./south/frame_003.png": 8088,
	"./west/frame_000.png": 449,
	"./west/frame_001.png": 2584,
	"./west/frame_002.png": 7859,
	"./west/frame_003.png": 282
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9795;